import { useCallback, useState } from 'react'
import axios from 'axios'

import { API_BASE_URL } from '../config/api'

/**
 * Stars a discovery from the Stats page.
 *
 * The page only knows the event id and the artist's name — not the entry's
 * whole artistsSeen array — so this hits the endpoint that toggles one artist
 * in place rather than sending the array back.
 *
 * Refetches stats afterwards instead of patching local state: starring changes
 * derived numbers elsewhere on the page (favourites list, artist history), and
 * recomputing server-side keeps them consistent.
 */
export const useArtistFavorite = (onChanged) => {
  const [error, setError] = useState('')

  const toggleLoved = useCallback(async (artist) => {
    setError('')

    try {
      await axios.put(
        `${API_BASE_URL}/api/events/${artist.eventId}/artists/favorite`,
        { artistName: artist.name, favorite: !artist.loved },
        { withCredentials: true }
      )

      if (onChanged) await onChanged()
    } catch (err) {
      if (process.env.NODE_ENV === 'development') console.error('Failed to toggle favorite:', err)
      setError(`Could not update ${artist.name}`)
      setTimeout(() => setError(''), 4000)
    }
  }, [onChanged])

  return { toggleLoved, error }
}
